import type { CarStats } from './CarTypes';

const kmhToMs = (kmh: number) => kmh / 3.6;

export const CAR_STARTER_ID = 'mini';

export const CAR_CATALOG: readonly CarStats[] = [
  {
    id: 'mini',
    name: 'Mini (Starter)',
    brand: 'Mini',
    model: 'Hatch',
    year: 2010,
    hp: 120,
    torqueNm: 160,
    drivetrain: 'FWD',
    topSpeedKmh: 190,
    zeroTo100: 9.6,
    price: 0,
    tier: 1,
    accel: 17.0,
    brake: 25.5,
    maxSpeed: kmhToMs(190),
    handling: 2.25,
    weight: 1150,
    grip: 10.2,
    driftGrip: 4.6,
    drag: 1.2
  },
  {
    id: 'ford',
    name: 'Ford (Street)',
    brand: 'Ford',
    model: 'Street',
    year: 2008,
    hp: 160,
    torqueNm: 220,
    drivetrain: 'RWD',
    topSpeedKmh: 220,
    zeroTo100: 8.0,
    price: 8500,
    tier: 1,
    accel: 20.0,
    brake: 28.0,
    maxSpeed: kmhToMs(220),
    handling: 2.05,
    weight: 1350,
    grip: 9.6,
    driftGrip: 3.9,
    drag: 1.24
  },
  {
    id: 'dodge',
    name: 'Dodge (Muscle)',
    brand: 'Dodge',
    model: 'Muscle',
    year: 2006,
    hp: 260,
    torqueNm: 420,
    drivetrain: 'RWD',
    topSpeedKmh: 240,
    zeroTo100: 6.2,
    price: 14500,
    tier: 1,
    accel: 23.5,
    brake: 29.5,
    maxSpeed: kmhToMs(240),
    handling: 1.85,
    weight: 1650,
    grip: 9.2,
    driftGrip: 3.6,
    drag: 1.3
  },
  {
    id: 'bmw',
    name: 'BMW (Coupe)',
    brand: 'BMW',
    model: 'Coupe',
    year: 2003,
    hp: 231,
    torqueNm: 300,
    drivetrain: 'RWD',
    topSpeedKmh: 250,
    zeroTo100: 6.4,
    price: 18000,
    tier: 2,
    accel: 24.5,
    brake: 31.0,
    maxSpeed: kmhToMs(250),
    handling: 2.1,
    weight: 1490,
    grip: 9.8,
    driftGrip: 3.7,
    drag: 1.26
  },
  {
    id: 'porsche',
    name: 'Porsche (Sport)',
    brand: 'Porsche',
    model: 'Sport',
    year: 2012,
    hp: 350,
    torqueNm: 390,
    drivetrain: 'RWD',
    topSpeedKmh: 290,
    zeroTo100: 4.8,
    price: 42000,
    tier: 2,
    accel: 28.0,
    brake: 34.0,
    maxSpeed: kmhToMs(285),
    handling: 2.15,
    weight: 1450,
    grip: 10.4,
    driftGrip: 3.9,
    drag: 1.22
  },
  {
    id: 'cybertruck',
    name: 'Cyber Truck (AWD)',
    brand: 'Cyber',
    model: 'Truck',
    year: 2020,
    hp: 450,
    torqueNm: 650,
    drivetrain: 'AWD',
    topSpeedKmh: 210,
    zeroTo100: 4.9,
    price: 48000,
    tier: 2,
    accel: 26.0,
    brake: 33.0,
    maxSpeed: kmhToMs(210),
    handling: 1.75,
    weight: 2500,
    grip: 10.6,
    driftGrip: 4.2,
    drag: 1.42
  },
  {
    id: 'r34',
    name: 'Skyline R34',
    brand: 'Nissan',
    model: 'Skyline R34',
    year: 1999,
    hp: 280,
    torqueNm: 392,
    drivetrain: 'AWD',
    topSpeedKmh: 250,
    zeroTo100: 5.2,
    price: 52000,
    tier: 2,
    accel: 28.5,
    brake: 34.0,
    maxSpeed: kmhToMs(255),
    handling: 2.0,
    weight: 1560,
    grip: 10.9,
    driftGrip: 4.0,
    drag: 1.32
  },
  {
    id: 'supra',
    name: 'Toyota Supra',
    brand: 'Toyota',
    model: 'Supra',
    year: 1998,
    hp: 330,
    torqueNm: 440,
    drivetrain: 'RWD',
    topSpeedKmh: 250,
    zeroTo100: 5.1,
    price: 65000,
    tier: 3,
    accel: 29.5,
    brake: 34.0,
    maxSpeed: kmhToMs(255),
    handling: 1.95,
    weight: 1560,
    grip: 10.1,
    driftGrip: 3.8,
    drag: 1.3
  },
  {
    id: 'r35',
    name: 'Nissan GT-R R35',
    brand: 'Nissan',
    model: 'GT-R R35',
    year: 2009,
    hp: 480,
    torqueNm: 588,
    drivetrain: 'AWD',
    topSpeedKmh: 310,
    zeroTo100: 3.6,
    price: 85000,
    tier: 3,
    accel: 33.0,
    brake: 36.0,
    maxSpeed: kmhToMs(305),
    handling: 2.05,
    weight: 1740,
    grip: 11.2,
    driftGrip: 4.2,
    drag: 1.35
  },
  {
    id: 'bugatti',
    name: 'Bugatti (Hyper)',
    brand: 'Bugatti',
    model: 'Hypercar',
    year: 2015,
    hp: 1000,
    torqueNm: 1250,
    drivetrain: 'AWD',
    topSpeedKmh: 380,
    zeroTo100: 2.6,
    price: 140000,
    tier: 3,
    accel: 40.0,
    brake: 38.0,
    maxSpeed: kmhToMs(360),
    handling: 1.85,
    weight: 1950,
    grip: 11.0,
    driftGrip: 4.4,
    drag: 1.45
  },
  {
    id: 'mercedes_safety',
    name: 'Mercedes AMG GTR Safety',
    brand: 'Mercedes-Benz',
    model: 'AMG GTR Safety Car',
    year: 2019,
    hp: 577,
    torqueNm: 700,
    drivetrain: 'RWD',
    topSpeedKmh: 318,
    zeroTo100: 3.6,
    price: 92000,
    tier: 3,
    accel: 34.0,
    brake: 36.0,
    maxSpeed: kmhToMs(312),
    handling: 2.12,
    weight: 1630,
    grip: 11.4,
    driftGrip: 4.0,
    drag: 1.31,
    isPolice: true // Polizeifahrzeug
  },
  {
    id: 'datsun_240k',
    name: 'Datsun 240K GT',
    brand: 'Datsun',
    model: '240K GT',
    year: 1972,
    hp: 185,
    torqueNm: 235,
    drivetrain: 'RWD',
    topSpeedKmh: 225,
    zeroTo100: 7.2,
    price: 36000,
    tier: 2,
    accel: 23.8,
    brake: 30.0,
    maxSpeed: kmhToMs(225),
    handling: 1.96,
    weight: 1270,
    grip: 9.5,
    driftGrip: 3.9,
    drag: 1.24
  },
  {
    id: 'hovercar',
    name: 'Cyberpunk Hovercar',
    brand: 'Cyberpunk',
    model: 'Hovercar',
    year: 2077,
    hp: 640,
    torqueNm: 820,
    drivetrain: 'AWD',
    topSpeedKmh: 340,
    zeroTo100: 3.2,
    price: 125000,
    tier: 3,
    accel: 36.0,
    brake: 35.0,
    maxSpeed: kmhToMs(330),
    handling: 1.88,
    weight: 1680,
    grip: 11.0,
    driftGrip: 4.3,
    drag: 1.2
  },
  {
    id: 'indian_traffic_pack',
    name: 'Indian Traffic Pack Car',
    brand: 'Indian Simulator',
    model: 'Traffic Car',
    year: 2021,
    hp: 210,
    torqueNm: 290,
    drivetrain: 'FWD',
    topSpeedKmh: 205,
    zeroTo100: 8.7,
    price: 24000,
    tier: 1,
    accel: 21.0,
    brake: 29.0,
    maxSpeed: kmhToMs(205),
    handling: 2.0,
    weight: 1320,
    grip: 9.3,
    driftGrip: 3.7,
    drag: 1.22
  },
  {
    id: 'indian_traffic_pack_2',
    name: 'Indian Pack Variant 2',
    modelVariantIndex: 1,
    brand: 'Indian Simulator',
    model: 'Traffic Variant 2',
    year: 2021,
    hp: 220,
    torqueNm: 305,
    drivetrain: 'FWD',
    topSpeedKmh: 212,
    zeroTo100: 8.4,
    price: 25000,
    tier: 1,
    accel: 21.6,
    brake: 29.2,
    maxSpeed: kmhToMs(212),
    handling: 2.03,
    weight: 1330,
    grip: 9.35,
    driftGrip: 3.72,
    drag: 1.23
  },
  {
    id: 'indian_traffic_pack_3',
    name: 'Indian Pack Variant 3',
    modelVariantIndex: 2,
    brand: 'Indian Simulator',
    model: 'Traffic Variant 3',
    year: 2021,
    hp: 228,
    torqueNm: 312,
    drivetrain: 'FWD',
    topSpeedKmh: 216,
    zeroTo100: 8.2,
    price: 26500,
    tier: 1,
    accel: 22.0,
    brake: 29.5,
    maxSpeed: kmhToMs(216),
    handling: 2.05,
    weight: 1340,
    grip: 9.4,
    driftGrip: 3.74,
    drag: 1.23
  },
  {
    id: 'indian_traffic_pack_4',
    name: 'Indian Pack Variant 4',
    modelVariantIndex: 3,
    brand: 'Indian Simulator',
    model: 'Traffic Variant 4',
    year: 2021,
    hp: 236,
    torqueNm: 320,
    drivetrain: 'FWD',
    topSpeedKmh: 220,
    zeroTo100: 8.0,
    price: 28000,
    tier: 1,
    accel: 22.3,
    brake: 29.8,
    maxSpeed: kmhToMs(220),
    handling: 2.08,
    weight: 1350,
    grip: 9.45,
    driftGrip: 3.75,
    drag: 1.24
  },
  {
    id: 'indian_traffic_pack_5',
    name: 'Indian Pack Variant 5',
    modelVariantIndex: 4,
    brand: 'Indian Simulator',
    model: 'Traffic Variant 5',
    year: 2021,
    hp: 245,
    torqueNm: 330,
    drivetrain: 'FWD',
    topSpeedKmh: 224,
    zeroTo100: 7.8,
    price: 29500,
    tier: 1,
    accel: 22.8,
    brake: 30.0,
    maxSpeed: kmhToMs(224),
    handling: 2.1,
    weight: 1360,
    grip: 9.5,
    driftGrip: 3.8,
    drag: 1.24
  }
] as const;

export const CAR_STATS: Record<string, { power: number; grip: number; maxSpeed: number }> = {
  mini: { power: 28, grip: 78, maxSpeed: 140 },
  ford: { power: 42, grip: 70, maxSpeed: 160 },
  dodge: { power: 56, grip: 62, maxSpeed: 168 },
  bmw: { power: 58, grip: 72, maxSpeed: 175 },
  porsche: { power: 75, grip: 80, maxSpeed: 185 },
  cybertruck: { power: 70, grip: 84, maxSpeed: 150 },
  r34: { power: 68, grip: 88, maxSpeed: 172 },
  supra: { power: 72, grip: 76, maxSpeed: 178 },
  r35: { power: 92, grip: 92, maxSpeed: 190 },
  bugatti: { power: 100, grip: 90, maxSpeed: 210 },
  mercedes_safety: { power: 94, grip: 92, maxSpeed: 198 },
  datsun_240k: { power: 54, grip: 74, maxSpeed: 166 },
  hovercar: { power: 98, grip: 88, maxSpeed: 205 },
  indian_traffic_pack: { power: 50, grip: 72, maxSpeed: 158 },
  indian_traffic_pack_2: { power: 52, grip: 73, maxSpeed: 160 },
  indian_traffic_pack_3: { power: 54, grip: 73, maxSpeed: 162 },
  indian_traffic_pack_4: { power: 56, grip: 74, maxSpeed: 164 },
  indian_traffic_pack_5: { power: 58, grip: 75, maxSpeed: 166 }
};

export const CAR_UNLOCK_COSTS: Record<string, number> = Object.fromEntries(
  CAR_CATALOG.map((c) => [c.id, c.price ?? 0])
);

export function getCarUnlockCost(carId: string): number {
  return CAR_UNLOCK_COSTS[carId] ?? 0;
}

export function getCarById(id: string): CarStats {
  return CAR_CATALOG.find((c) => c.id === id) ?? CAR_CATALOG[0];
}

export function getCarTier(id: string): 1 | 2 | 3 {
  return (getCarById(id).tier ?? 1) as 1 | 2 | 3;
}

export function getCarByIndex(index: number): CarStats {
  const i = Math.max(0, Math.min(CAR_CATALOG.length - 1, index));
  return CAR_CATALOG[i];
}

export function getCarIndexById(id: string): number {
  const idx = CAR_CATALOG.findIndex((car) => car.id === id);
  return idx >= 0 ? idx : 0;
}

